
import { Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IDataGridPageRequest } from "shared";
import { delay } from 'rxjs/operators';
import { CORE_FUNCTIONS, IPaginationResponse, IServerResponse, TipoComunidadEnum } from '@app/core';
import { environment } from "src/environments/environment";

@Injectable()
export class ProgramaService {
  private url: string = `${environment.baseUrlAPIDWH}/localprograma`;
  private urlMatricula: string = `${environment.baseUrlAPIDWH}/matricula`;
  private urlIngresos: string = `${environment.baseUrlAPIDWH}/ingresos`;
  private urlPostulante: string = `${environment.baseUrlAPIDWH}/postulante`;

  constructor(
    private http: HttpClient
  ) { }

  listarProgramas = (pageRequest: IDataGridPageRequest, filters: any) => {

    return this.http.post<IServerResponse<any[]>>(`${this.url}/listar`, {
      ...pageRequest,
      ...filters
    });
  }

  listarPrograma = (id: number, idUniversidad: number) => {
    // const data = { userGeoCoordinate };
    return this.http.get<IServerResponse<any>>(
      `${this.url}/${idUniversidad}/${id}`
    );
  }

  listarLocales = (idPrograma: number, idEntidad: number, idProgramaDocumento:number) => {
    return this.http.post<IServerResponse<any>>(
      `${this.url}/listarlocales`, {
      idPrograma,
      idEntidad,
      idProgramaDocumento
    });
  }

  listarComunidadEstudiantil = (filters: any) => {
    const cleanFilters = {
      ...filters,
      idPrograma: CORE_FUNCTIONS.ifNull(filters.idPrograma, 0),
      idNivelAcademico: CORE_FUNCTIONS.ifNull(filters.idNivelAcademico, 0),
    };

    return this.http.post<IServerResponse<any>>(`${this.urlMatricula}/detalleprograma`, cleanFilters);
  }

  listarComunidadEstudiantilIngresos = (filters: any) => {
    const cleanFilters = {
      ...filters,
      idProgramaDocumento: CORE_FUNCTIONS.ifNull(filters.idProgramaDocumento, 0),
      idNivelAcademico: CORE_FUNCTIONS.ifNull(filters.idNivelAcademico, 0),
    };

    return this.http.post<IServerResponse<any>>(`${this.urlIngresos}/detalleprograma`, cleanFilters);
  }

  listarDetalleProgramaComunidad = (pageRequest: IDataGridPageRequest, filters: any) => {
    const cleanFilters = {
      ...pageRequest,
      ...filters,
      idEntidad: CORE_FUNCTIONS.ifNull(filters.idEntidad, 0),
      idProgramaDocumento: CORE_FUNCTIONS.ifNull(filters.idProgramaDocumento, 0),
      idNivelAcademico: CORE_FUNCTIONS.ifNull(filters.idNivelAcademico, 0),
      soloMatriculado: filters.idComunidadEstudiantil == TipoComunidadEnum.ESTUDIANTE ? true : false
    };

    return this.http.post<IServerResponse<any>>(`${this.urlMatricula}/DetalleProgramaComunidad`, cleanFilters);
  }

  listarComunidadEstudiantilPostulantes = (filters: any) => {
    const cleanFilters = {
      ...filters,
      idProgramaDocumento: CORE_FUNCTIONS.ifNull(filters.idProgramaDocumento, 0),
      idNivelAcademico: CORE_FUNCTIONS.ifNull(filters.idNivelAcademico, 0),
    };

    return this.http.post<IServerResponse<any>>(`${this.urlPostulante}/detalleprograma`, cleanFilters);
  }

}
